import { ClockFading } from "lucide-react";
import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getEventsRequest, getEventsRequestError, getEventsRequestSuccess } from "../../slices/event-management/GetEventsSlice";

export const GetEventsApi = (currentPage, limit, search, sport, eventType, status, location) => async (dispatch) => {

    console.log(location, "dvsfv")

    const queryParams = new URLSearchParams({
        page: currentPage || 1,
        limit: limit || 5,
        search: search || '',
        event_type: eventType || '',
        location: location || '',
        status: status || '',
        sports_category: sport || ''
    }).toString();

    const urlWithParams = `${endpoints.events}?${queryParams}`;
    try {
        dispatch(getEventsRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getEventsRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getEventsRequestError(_error));
            });
    } catch (error) { }
};
